import { QueryClient } from '@tanstack/react-query';
import { createRouter as createTanstackRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen.ts';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000 },
  },
});

// No explicit return annotation and no cast on `routeTree` on purpose: both
// erase the generated route tree's types. `ReturnType<typeof createTanstackRouter>`
// instantiates the factory's defaults (`AnyRoute`), and that erased router is
// what `Register` below publishes, so every `Route.useParams()` /
// `Route.useSearch()` in the app degrades to `any` and each route has to narrow
// its own params by hand. Let inference carry `routeTree` through instead.
export const createRouter = (): ReturnType<typeof createTanstackRouter<typeof routeTree>> =>
  createTanstackRouter({
    routeTree,
    defaultPreload: 'intent',
    context: { queryClient },
  });

export const router = createRouter();

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}
